import React from "react";
import "./VerticalTimeline.scss";

export interface TimelineItem {
  id: string;
  image: any;
  onclick: () => void;
  content: React.ReactNode;
}

interface VerticalTimelineProps {
  items: TimelineItem[];
}

const VerticalTimeline: React.FC<VerticalTimelineProps> = ({ items }) => {
  return (
    <div className={"timelineContainer"}>
      <div className={"timelineLine"} /> {/* ✅ single full-height line */}
      {items.map((item) => (
        <div className={"timelineItem"} key={item.id}>
          <div className={"timelineLeft"}>{item.image}</div>
          <div onClick={item.onclick} className={"timelineRight"}>
            {item.content}
          </div>
        </div>
      ))}
    </div>
  );
};

export default VerticalTimeline;
